export const DEFAULT_USER = {
  id: 1,
  is_bot: false,
  first_name: 'Tester',
  last_name: 'User',
  username: 'tester',
  language_code: 'en',
} as const;

export const DEFAULT_CHAT = {
  id: 1,
  type: 'private',
  first_name: 'Tester',
  last_name: 'User',
  username: 'tester',
} as const;

export const SSE_RECONNECT_DELAY = 3000;
export const NOTIFICATION_DURATION = 3000;
export const MAX_NOTIFICATIONS = 3;
